import { render, staticRenderFns } from "./AffectClientToResponsibleModal.vue?vue&type=template&id=2c32e9bc&"
import script from "./AffectClientToResponsibleModal.vue?vue&type=script&lang=js&"
export * from "./AffectClientToResponsibleModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports